export default __webpack_public_path__ + "static/media/php7-negative.ef683aaa.svg";